/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { difference } from 'lodash';
import { selectFormValidationData } from '../../../app/common/validators/store/validators.selectors';

xplenty.directive('ngSubmit', [
  '$rootScope',
  '$timeout',
  '$state',
  '$compile',
  '$translate',
  'notify',
  'ngrxStoreService',

  function ($rootScope, $timeout, $state, $compile, $translate, notify, ngrxStoreService) {
    return {
      restrict: 'A',

      require: '?form',

      priority: 10,

      link: {
        pre(scope, element, attrs, form) {
          let action = null;

          if (angular.isUndefined(attrs.action)) {
            action = $state.current.data ? $state.current.data.action : 'new';
          } else {
            action = attrs.action;
          }

          $timeout(function () {
            if (form.$name === 'connectionForm') {
              action = angular.element('.connection-form').data('id') === '' ? 'new' : action;
            }

            if (form.$name === 'clusterForm') {
              action = angular.element('.cluster-form').data('id') === '' ? 'new' : action;
            }

            form.$new = action === 'new';
          });

          form.$submiting = false;

          element.on('submit', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            scope._submit();
          });
        },

        post(scope, element, attrs, form) {
          $rootScope.$log.info(`Initialize form: ${form.$name}`);
          let previousKeys = [];

          const subscription = ngrxStoreService.pipe(selectFormValidationData(form.$name)).subscribe((formData) => {
            Object.keys(formData).forEach((key) => {
              const formField = form[key];

              if (formField) {
                form[key].$setValidity(key, formData[key]);
              }
            });

            difference(previousKeys, Object.keys(formData)).forEach((key) => {
              if (form[key]) {
                form[key].$setValidity(key, true);
              }
            });

            previousKeys = Object.keys(formData);
          });

          const submitFunctionName = element.attr('ng-submit');
          let submitFunction = null;

          if (angular.isUndefined(submitFunctionName)) {
            $rootScope.$log.error('Error (form.directive): Provide form ng-submit function');
            return;
          }
          const cleanFunctionName = submitFunctionName.substring(0, submitFunctionName.indexOf('('));
          // check if function name is a property name or a json path. if json path, iterate until you reach the end of the path
          if (cleanFunctionName.includes('.')) {
            const jsonBreakdown = cleanFunctionName.split('.');
            let obj;
            _.each(jsonBreakdown, (value, index) => {
              if (index < jsonBreakdown.length - 1) {
                if (!obj) obj = scope[value];
                else obj = obj[value];
              } else {
                submitFunction = obj[value];
              }
            });
          } else {
            submitFunction = scope[cleanFunctionName];
          }

          if (!angular.isFunction(submitFunction)) {
            $rootScope.$log.error("Error (form.directive): Submit function doesn't exist in the scope");
            return;
          }

          const appendSubmitButton = function () {
            const $fakeSubmitButton = angular.element('<input type="submit">');
            $fakeSubmitButton.css({
              position: 'absolute',
              left: '-9999px',
              width: '1px',
              height: '1px',
            });
            element.append($fakeSubmitButton);
          };

          if (element.find('[type="submit"]').length === 0) {
            appendSubmitButton();
          }

          const setFormControlError = function (error) {
            if (error.field === 'base') return;

            const classes = 'ng-invalid';
            const $formElement = element.find(`[name="${error.field}"]`);
            const $messageElement = element.find(`[data-field-type="${error.field}"].input-error-message`);
            const $messageSpanElement = $messageElement.find('span');

            $translate(error.fieldNameKey).then(function (translation) {
              $timeout(function () {
                // Translate the field name
                $formElement.addClass(`${classes} ng-touched ng-dirty`);
                $messageSpanElement.text([translation, error.message].join(' '));
                $messageElement.removeClass('hidden');
              });
            });

            var bindError = function () {
              if ($errorBox) $errorBox.remove();
              $formElement.removeClass(classes);
              $messageElement.addClass('hidden');
              $formElement.off('click', bindError);
              $formElement.off('focus', bindError);
            };

            $formElement.on('click', bindError);
            $formElement.on('focus', bindError);
          };

          let $errorBox;

          const createErrorBox = function (errors) {
            if ($errorBox) $errorBox.remove();

            // Build error messages using a template?
            const message = errors
              .map(function (error) {
                const $wrapper = $('<span></span>');
                const key = $translate.instant(error.fieldNameKey);

                if (key !== 'base') {
                  $wrapper.append($('<strong></strong>').text(`${key} `));
                }
                $wrapper.append($('<span></span>').text(error.message));
                return $wrapper.html();
              })
              .join('<br>');

            //

            const $modalBody = element.closest('.modal-body');
            if ($modalBody.length) {
              $timeout(function () {
                notify.alertModal(null, message, null, {
                  element: $modalBody,
                  type: 'warning',
                  newest_on_top: false,
                  onShow() {
                    $errorBox = $(this);
                  },
                });
              });
            } else {
              $timeout(function () {
                notify.alert(null, message, null, {
                  type: 'warning',
                  delay: 7000,
                  onShow() {
                    $errorBox = $(this);
                  },
                  mergeError: true,
                });
              });
            }
          };

          const error = function (res) {
            form.$submiting = false;

            const validationType = element.parent().attr('type');
            const data = res.data || res.error;

            if (data.errors) {
              const errors = _.map(data.errors, function (e, key) {
                e.fieldNameKey = e.field !== 'base' ? [validationType, 'labels', e.field || key].join('.') : '';
                e.message = e.message || e;
                return e;
              });

              _.each(errors, setFormControlError);

              createErrorBox(errors);
            } else if (data.message) {
              createErrorBox([
                {
                  fieldNameKey: '',
                  field: 'base',
                  message: data.message,
                },
              ]);
            } else {
              // TODO: add generic error
            }
          };

          const success = function () {
            form.$submiting = false;

            // Make sure to clear any validation errors
            form.$setUntouched();

            // Get success message from specific form.
            if (angular.isDefined(attrs.successMessageText)) {
              notify.success(
                angular.isDefined(attrs.successMessageTitle) ? attrs.successMessageTitle : null,
                attrs.successMessageText,
              );
            }
          };

          scope._submit = function () {
            if (form.$invalid || form.$submiting) return;

            form.$submiting = true;

            const submitFunctionCallback = submitFunction();

            if (submitFunctionCallback && submitFunctionCallback.$promise) {
              submitFunctionCallback.$promise.then(success);
              submitFunctionCallback.$promise.catch(error);
            } else if (submitFunctionCallback && submitFunctionCallback.subscribe) {
              submitFunctionCallback.subscribe(success, error);
            } else {
              $rootScope.$log.error('Error (form.directive): Provide function with promise');
            }
          };

          form._submit = scope._submit;

          scope.$on('$destroy', () => {
            if (subscription) {
              subscription.unsubscribe();
            }
          });
        },
      },
    };
  },
]);
